import { BookingStatus, PaymentStatus } from '../types/booking.types.js';

export const BOOKING_STATUS_LABELS = {
  [BookingStatus.PENDING]: '待确认',
  [BookingStatus.CONFIRMED]: '已确认',
  [BookingStatus.CANCELLED]: '已取消',
  [BookingStatus.REFUNDED]: '已退款',
  [BookingStatus.CANCELLED_CREDIT]: '已取消（余额退款）',
  [BookingStatus.CANCELLED_REFUND]: '已取消（原路退款）',
  [BookingStatus.CANCELLED_PASS]: '已取消（Pass 预约）',
  [BookingStatus.CANCELLED_BY_HOST]: '待退款（活动取消）',
  [BookingStatus.TRANSFERRED]: '已转让',
} as const;

export const STRIPE_REFUND_FEE_PERCENT = 5; // 5% fee for Stripe refunds
export const MIN_CANCEL_HOURS_BEFORE_START = 24; // Must cancel >24h before start

export const PAYMENT_STATUS_LABELS = {
  [PaymentStatus.PENDING]: '待支付',
  [PaymentStatus.SUCCEEDED]: '支付成功',
  [PaymentStatus.FAILED]: '支付失败',
  [PaymentStatus.REFUNDED]: '已退款',
} as const;
